<div class="map-container">
    <div class="map-frame">
        <div #map_elementRef [attr.id]="mapSetUp.id" class="map-elementRef"></div>
    </div>
</div>